"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = detectDomainRealm;
var SUBDOMAIN_REALM_MAP = {
  na: 'USAmazon',
  eu: 'EUAmazon',
  fe: 'FEAmazon',
  cn: 'CNAmazon'
};

function detectDomainRealm() {
  var realm = detectRealmFromSurl();
  var domain = detectDomainFromSurl();
  return {
    domain: domain,
    realm: realm
  };
}

function detectDomainFromSurl() {
  var surl = window.ue_surl;

  if (surl) {
    if (surl.indexOf('nexusclient.prod') !== -1) {
      return 'prod';
    } else if (surl.indexOf('nexusclient.gamma') !== -1) {
      return 'test';
    }
  }
}

function detectRealmFromSurl() {
  var surl = window.ue_surl;

  if (surl) {
    var subdomain = surl.match(/unagi[-]([a-z]{2})/);

    if (subdomain) {
      return SUBDOMAIN_REALM_MAP[subdomain[1]];
    }
  }
}